
export const ErrorIcon = () => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" stroke="#DC4732" xmlns="http://www.w3.org/2000/svg">
    <circle cx="10" cy="10" r="9.25" strokeWidth="1.5" />
    <path
      d="M7.16019 7.10376L10.0271 9.97069M12.894 12.8376L10.0271 9.97069M10.0271 9.97069L7.14062 12.8572L12.894 7.10376"
      strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);
